import React, { useEffect } from 'react'
import { useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import Select from 'react-select'
import DashboardLayout from '../../components/DashboardLayout';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { api_url, AXIOS_HEADER } from '../../constants/data';
import moment from 'moment';

const TaskForward = () => {
    const navigate = useNavigate(); 
    const [isChecked1, setIsChecked1] = useState(false);
    const [isChecked2, setIsChecked2] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null)
    const fileTypes = ["jpg", "png", "pdf", "xlxs", "doc"];
    const [task, setTask] = useState(null);   
    const { id } = useParams();
    const[selectForwards, setSelectForwards] = useState([])

    useEffect(() => {
        axios.post(`${api_url}/task/${id}`, {}, AXIOS_HEADER)
            .then((res) => {
                setTask(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [id])

    const handleCheckbox1Change = () => {
        setIsChecked1(!isChecked1);
        setIsChecked2(false);
        console.log("alert1");
    };

    const handleCheckbox2Change = () => {
        setIsChecked2(!isChecked2);
        setIsChecked1(false);
        console.log("alert2");
    };

    const forwardUserHandler = items => {
        const ids = []
        items.map(x => {
            ids.push(x.value)
        })

        setSelectForwards([...ids])
    }

    if(!task) {
        return <div>Loading...</div>
    }

    const submit = () => {
        const payload = {
            forwards: selectForwards,
            task_id: id
        }

        axios.post(`${api_url}/task/${id}/forward`, payload, AXIOS_HEADER)
            .then(res => {
                navigate(`/task/${id}`)
            })
            .catch(err => {
                console.log(err)
            })
    }

    return (
        <DashboardLayout>
            <div className="header_wrapper">
                <div className="header_icon">
                    <img src="/icons/flag.png" alt="" />
                </div>
                <div className="header_title">
                    <p>დაფორვარდება</p>
                </div>
            </div>
            <div className="task-details-main">
                <div className="task-details-header">
                    <span className='author'>ჩანაწერის ავტორი: <p>{ task.user.name } { task.user.lastname }</p></span>
                    {/* <div className="checkboxes">
                        <label htmlFor="checkbox1">
                            <input type="checkbox"
                                id="checkbox1"
                                checked={isChecked1}
                                onChange={handleCheckbox1Change} />
                            <span class="fake-checkbox"></span>
                            <span class="text">შესრულება</span>
                        </label>
                        <label htmlFor="checkbox2">
                            <input type="checkbox"
                                id="checkbox2"
                                checked={isChecked2}
                                onChange={handleCheckbox2Change} />
                            <span class="fake-checkbox"></span>
                            <span class="text">გაუქმება</span>
                        </label>
                    </div> */}
                </div>
                <form action="">
                    <div className='task-details-inner'>
                        <div className="task-details-option">
                            <p>დასაწყისი:</p>
                            <strong>{ moment(task.date_start).format('YYYY-MM-DD') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>დასასრული:</p>
                            <strong>{ moment(task.date_end).format('YYYY-MM-DD') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>დავალება:</p>
                            <strong>{ task.title }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>განყოფილება:</p>
                            <strong>{ task.departments.map(x => x.department.short_name).join(', ') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>შემსრულებელი:</p>
                            <strong>{ task.users.filter(x => x.is_cc == 0).map(x => x.user.name + " " + x.user.lastname).join(', ') }</strong>
                        </div>
                        <div className="task-details-option cc">
                            <p>Cc:</p>
                            <strong>{ task.users.filter(x => x.is_cc == 1).map(x => x.user.name + " " + x.user.lastname).join(', ') }</strong>
                        </div>
                        <div className="task-details-option">
                            <p>მიბმული ფაილი:</p>
                            { task.attachments && task.attachments.map((attachment, index) => (
                                <a href={attachment.file} target='blank' key={index}>ფაილი_{index}</a>  
                            ))}
                        </div>
                        <div className="task-details-option">
                            <p>Forward:</p>
                            <div className="form_control" style={{ marginLeft: '20px'}}>
                                <Select options={task.forwards.map(x => {
                                    return { value: x.id, label: x.name + ' ' + x.lastname }
                                })} isMulti onChange={forwardUserHandler } />
                            </div>
                        </div>
                        <div className="task-details-option">
                            <p>შინაარსი:</p>
                            <strong>{ task.description }</strong>
                        </div>
                    </div>
                    <div className="task-details-buttons">
                        <button type='button' onClick={() => navigate(`/task/${id}`)}>უკან</button>
                        <button type='button' onClick={submit}>შენახვა</button>
                    </div>
                    <span className="taskread">დავალება წაიკითხა: <p>{ task.user_read_info.map(x => x.user.username).join(', ') }</p></span>
                    <button className="comentsbutton" type='button'>
                        <img src="/icons/chat1.png" alt="" />
                        <p>კომენტარები</p>
                    </button>
                  
                    
                </form>
            </div >
        </DashboardLayout>
        
    )
}

export default TaskForward